import conversationDetailModule from '@/store/modules/conversation-detail.module'
import analyticsFilterModule from '@/store/modules/analytics-filter.module'

class ConversationNavigationUtils {

  getRequests() {
    const messages = conversationDetailModule.getMessages()
    const filteredOutcomes = analyticsFilterModule.getRequestOutcomes()
    return messages.filter(({ data, newRequestLegend }) => {
      return (
        data.direction?.toLowerCase() === 'received' &&
        !!newRequestLegend &&
        (!filteredOutcomes || filteredOutcomes.includes(newRequestLegend))
      )
    })
  }

  getTargetMessage(step, requestId) {
    const requests = this.getRequests()
    const selectedRequestIndex = requests.findIndex(({ data }) => data.message_id === requestId)
    return requests[selectedRequestIndex + step]
  }

  getTargetConversation(step, conversations, contactId) {
    const selectedConversationIndex = conversations.findIndex(({ contact_id }) => contact_id === contactId)
    return conversations[selectedConversationIndex + step]
  }
}

export const conversationNavigationVueUtils = (conversationNavigationUtils) => {

  return {
    props: {
      isConversationLoading: {
        type: Boolean,
        default: false
      },
      conversations: {
        type: Array,
        default: () => []
      },
      contactId: {
        type: String,
        default: ''
      }
    },

    computed: {
      requests: conversationDetailModule.getRequests,
      intentSuggestions: conversationDetailModule.getIntentSuggestions,

      previousConversation() {
        return conversationNavigationUtils.getTargetConversation(-1, this.conversations, this.contactId)
      },

      previousRequest() {
        return conversationNavigationUtils.getTargetMessage(-1, this.$route.query.requestId)
      },

      nextRequest() {
        return conversationNavigationUtils.getTargetMessage(1, this.$route.query.requestId)
      },

      nextConversation() {
        return conversationNavigationUtils.getTargetConversation(1, this.conversations, this.contactId)
      }
    },

    methods: {
      emitSelectedMessage(message) {
        if (message.id === this.$route.query.requestId) return

        this.$emit('bubble-selected', {
          firstRequest: message.data.content.payload,
          messageId: message.data.message_id,
          requestId: this.requests[message.data.message_id]?.id,
          intentSuggestion: this.intentSuggestions[message.data.message_id],
          goToTargetMessage: true
        })
      },

      selectTargetConversation(step) {
        const nextConversation = conversationNavigationUtils.getTargetConversation(
          step,
          this.conversations,
          this.contactId
        )
        if (!nextConversation) return

        this.$emit('select-conversation', nextConversation.contact_id)
        // to record that conversation was changed automatically by browsing through requests
        this.stepForwardWasClicked = step > 0
        this.stepBackWasClicked = step < 0
      },

      async gotToTargetMessage(step) {
        const targetMessage = conversationNavigationUtils.getTargetMessage(
          step,
          this.$route.query.requestId,
          this.stepForwardWasClicked,
          this.stepBackWasClicked
        )
        if (!targetMessage) {
          this.selectTargetConversation(step)
          return
        }

        // give a time to current bubble to rerender before switching to next one
        await this.$nextTick()
        this.emitSelectedMessage(targetMessage)
      }
    }
  }
}

export default new ConversationNavigationUtils()
